import { Link } from 'react-router-dom';
import { IconArrowLeft } from '@tabler/icons-react';
import { useAuth } from '../context/AuthContext';
import './InfoPage.scss';

export default function InfoPage() {
    const { isAuthenticated } = useAuth();

    return (
        <div className="info-page">
            <h1 className="info-page__brand">Контакты</h1>
            <p className="info-page__subtitle">Реквизиты</p>

            <div className="info-page__content">
                <div className="info-page__block">
                    <div className="info-page__contacts">
                        <div className="info-page__contact-row">
                            <span className="info-page__contact-label">Почта</span>
                            <a href="mailto:info@bypass-vpn.ru" className="info-page__contact-value">info@bypass-vpn.ru</a>
                        </div>
                        <div className="info-page__contact-row">
                            <span className="info-page__contact-label">Владелец</span>
                            <span className="info-page__contact-value info-page__contact-value--plain">Хамдохов Арсен Русланович</span>
                        </div>
                        <div className="info-page__contact-row">
                            <span className="info-page__contact-label">ИНН</span>
                            <span className="info-page__contact-value info-page__contact-value--plain">070709952572</span>
                        </div>
                    </div>
                </div>

                <Link to="/help" className="info-page__help-link">
                    Полная справка
                </Link>
            </div>

            {isAuthenticated ? (
                <Link to="/subscriptions" className="btn btn--primary btn--fixed info-page__back">
                    <IconArrowLeft size={18} stroke={1.5} />
                    К моим подпискам
                </Link>
            ) : (
                <Link to="/login" className="btn btn--primary btn--fixed info-page__back">
                    <IconArrowLeft size={18} stroke={1.5} />
                    На страницу входа
                </Link>
            )}
        </div>
    );
}
